import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useMediaQuery,
} from '@mui/material'
import MainHeader from '../shared/organism/MainHeader'
import React from 'react'
import AccSecurity from '../shared/molecule/AccSecurity'
import { theme } from '../../theme/DashboardTheme'
import { ExpandMore } from '@mui/icons-material'
import PageLayout from './PageLayout'

export const SettingsView = () => {

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <PageLayout>
      <MainHeader title={'Settings'} />
      {isMobile ? (
        <div style={{ marginBlock: '1rem' }}>
          <Accordion sx={{boxShadow: 'none'}}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1-content">
              Account & Security
            </AccordionSummary>
            <AccordionDetails>
              <AccSecurity />
            </AccordionDetails>
          </Accordion>
        </div>
      ) : (
        <AccSecurity />
      )}
    </PageLayout>
  )
}